import { React, useState } from 'react'
import './CoursesItem.css'
import { FaRegComment } from 'react-icons/fa'
import { BsBookmark } from 'react-icons/bs'
import { Link, useNavigate } from 'react-router-dom'
import { axiosConfig } from '../../Configuration/axios/axiosConfiguration'
import { toast } from 'react-toastify'

export default function CoursesItem({ backgroundColor, item }) {
    const [courseBookmark, setCourseBookmark] = useState(
        item.courseSaves?.filter(p => p.registererId == localStorage.getItem("userId")).length != 0 ? true : false
    )
    const currentDate = new Date();
    const nav = useNavigate();
    function saveCourse() {
        axiosConfig
            .post("api/courses/courseSave/" + item.id)
            .then((result) => {
                toast.success("با موفقیت دوره سیو شد", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
                setCourseBookmark(true);
            })
            .catch((res) => {
                if (res.response.status == 401) {
                    nav("/login");
                }
            });
    }
    function deleteSaveCourse() {
        axiosConfig
            .delete("api/courses/courseSave/" + item.id)
            .then((result) => {
                toast.success("با موفقیت دوره سیو شده حذف شد", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
                setCourseBookmark(false);
            })
            .catch((res) => {
                if (res.response.status == 401) {
                    nav("/login");
                }
            });
    }
    return (
        <>
            <div className='popular-courses-item'>
                <div className='courses-item-top'>
                    <div className='courses-item-color' style={{ backgroundColor: backgroundColor }}>
                    </div>
                    <div className='courses-item-icons'>
                        <div className='courses-item-icon-right'>
                            <FaRegComment />
                        </div>
                        <Link to={"/course/" + item.title}>
                            <div className='course-item-image'>

                                <img src={axiosConfig.defaults.baseURL +
                                    "Images/CourseImage/"
                                    + item.id +
                                    "/"
                                    + item.imagePath
                                } alt={item.title} style={{ borderColor: backgroundColor }} />
                            </div>
                        </Link>
                        <div className={`courses-item-icon-left ${courseBookmark ? 'active' : ''}`}>
                            <BsBookmark onClick={courseBookmark ? deleteSaveCourse : saveCourse} />
                        </div>
                    </div>
                </div>
                <div className='courses-item-bottom'>
                    <Link to={"/course/" + item.title}>
                        <h1 className='course-item-title'>{item.title}</h1>
                        <div className='courses-item-tags'>
                            <div className='courses-item-student' >
                                {item.studentCount} دانشجو
                            </div>
                            <div className='courses-item-level'>
                                {
                                    item.courseLevel == 0 ? (
                                        <span>مبتدی</span>
                                    ) : (
                                        item.courseLevel == 1 ? (
                                            <span>متوسط</span>
                                        ) : (
                                            <span>پیشرفته</span>
                                        )
                                    )
                                }
                            </div>
                        </div>
                        {
                            item.discount != null && new Date(item.discount.startTime).getTime() >= currentDate.getTime()
                                && new Date(item.discount.startTime).getTime() <= currentDate.setDate(currentDate.getDate() + parseInt(item.discount.duration)) ? (
                                <>
                                    <div className='price-text'>
                                        قیمت
                                    </div>
                                    <div className='course-item-price'>
                                        <div className='prev-current-price'>
                                            <span className='prev-price'>{item.price.toLocaleString("fa-IR")}</span>
                                            <span className='current-price'>{(item.price - ((item.price * item.discount.percent) / 100)).toLocaleString("fa-IR")} تومان</span>
                                        </div>
                                        <div className='course-item-off'>
                                            {item.discount.percent}%
                                        </div>
                                    </div>
                                </>
                            ) : (
                                <>
                                    <div className='price-text' style={{ bottom: "2.7rem" }}>
                                        قیمت
                                    </div>
                                    <div className='course-item-price'>
                                        {
                                            item.price == 0 ? (
                                                <>
                                                    <div className='prev-current-price'>
                                                        <span className='current-price' style={{ color: "green" }}>رایگان</span>
                                                    </div>
                                                </>
                                            ) : (
                                                <>
                                                    <div className='prev-current-price'>
                                                        <span className='current-price'>{item.price.toLocaleString("fa-IR")} تومان</span>
                                                    </div>
                                                </>
                                            )
                                        }
                                    </div>
                                </>

                            )
                        }
                    </Link>

                </div>
            </div>

        </>

    )
}
